export type BrandProfileFieldType = 'text' | 'text[]' | 'integer[]';

/**
 * Brand profile field keys as returned by the API (snake_case).
 * Use these enum members in frontend code instead of raw strings.
 */
export enum BrandProfileFieldName {
    OrganizationName = 'organization_name',
    BrandDescription = 'brand_description',
    BrandToneKeywords = 'brand_tone_keywords',
    UseKeywords = 'use_keywords',
    DontUseKeywords = 'dont_use_keywords',
    SampleTemplateIds = 'sample_template_ids',
}

/** Single field row as returned by the brand profile API (matches backend / DB columns). */
export type BrandProfileFieldApi = {
    id: number;
    field_name: string;
    weightage: number;
    is_required: boolean;
    input_type: BrandProfileFieldType;
    current_value: string | string[] | number[] | null;
    last_modified_by_user_id?: string;
    allowed_values?: string[];
    created_timestamp: string;
    last_modified_timestamp: string;
};

export type BrandProfileResponseApi = BrandProfileFieldApi[];

/** Frontend model: camelCase properties mapped from {@link BrandProfileFieldApi}. */
export type BrandProfileField = {
    id: number;
    fieldName: BrandProfileFieldName | string;
    weightage: number;
    isRequired: boolean;
    inputType: BrandProfileFieldType;
    currentValue: string | string[] | number[] | null;
    lastModifiedByUserId?: string;
    allowedValues?: string[];
    createdTimestamp: string;
    lastModifiedTimestamp: string;
};

export type BrandProfileResponse = BrandProfileField[];

/** PUT body: keys are API field names (use {@link BrandProfileFieldName} values). */
export type BrandProfilePayload = Record<string, string | string[] | number[] | null>;
